import Avatar from '../Avatar';
import { getHistory, errorText } from '../api';
import { useLoad, when, agentFor } from '../fmt';

// History kind → [label, prototype .tp class]
const KIND = { read: ['Looked up', 'read'], drafted: ['Drafted', 'write'], approved: ['Approved', 'ok'], rejected: ['Rejected', 'rej'], error: ['Problem', 'error'] };

export default function History({ agentsById, version }) {
  const { data, error, loading } = useLoad(getHistory, [version]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className="vh"><div><h2>History</h2><p>Every lookup, change and approval. Changes always show who approved them.</p></div></div>
      {error && <div className="err">{errorText(error)}</div>}
      {!error && (data || !loading) && (data && data.length ? (
        <div className="tblw hist">
          <table>
            <thead><tr><th>Time</th><th>Employee</th><th>What happened</th><th>Type</th></tr></thead>
            <tbody>
              {data.map((l) => {
                const a = agentFor(agentsById, l);
                const [lab, cls] = KIND[l.kind] || [l.kind, 'read'];
                return (
                  <tr key={l.id}>
                    <td style={{ fontVariantNumeric: 'tabular-nums' }}>{when(l.createdAt)}</td>
                    <td><span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>{a && (!a.removed || a.look) && <Avatar agent={a} size="sm" />}{a ? a.name : ''}{a && a.removed && <span style={{ color: 'var(--muted)' }}>(left)</span>}</span></td>
                    <td>{l.text}</td>
                    <td><span className={`tp ${cls}`}>{lab}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : <div className="panel empty">Nothing has happened yet. Every lookup, draft and approval will be listed here.</div>)}
    </div>
  );
}
